import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/LoginPage'));
const SignupPage = lazy(() => import('../pages/auth/SignupPage'));
const OnboardingPage = lazy(() => import('../pages/onboarding/OnboardingPage'));
const DashboardPage = lazy(() => import('../pages/dashboard/DashboardPage'));
const ExperiencePage = lazy(() => import('../pages/experience/ExperiencePage'));
const ReconnectionPage = lazy(() => import('../pages/reconnection/ReconnectionPage'));
const SettingsPage = lazy(() => import('../pages/settings/SettingsPage'));
const HistoryPage = lazy(() => import('../pages/history/HistoryPage'));
const AIChatPage = lazy(() => import('../pages/ai-chat/AIChatPage'));
const AIHistoryPage = lazy(() => import('../pages/ai-history/AIHistoryPage'));
const AchievementsPage = lazy(() => import('../pages/achievements/AchievementsPage'));
const AlbumPage = lazy(() => import('../pages/album/AlbumPage'));
const PrivacyPage = lazy(() => import('../pages/privacy/PrivacyPage'));
const TermsPage = lazy(() => import('../pages/terms/TermsPage'));
const AboutPage = lazy(() => import('../pages/about/AboutPage'));
const PremiumSuccessPage = lazy(() => import('../pages/premium/PremiumSuccessPage'));
const PremiumCancelPage = lazy(() => import('../pages/premium/PremiumCancelPage'));
const PaymentHistoryPage = lazy(() => import('../pages/premium/PaymentHistoryPage'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('../pages/auth/ResetPasswordPage'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/cadastro',
    element: <SignupPage />,
  },
  {
    path: '/onboarding',
    element: <OnboardingPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/experiencia/:type',
    element: <ExperiencePage />,
  },
  {
    path: '/reconexao',
    element: <ReconnectionPage />,
  },
  {
    path: '/configuracoes',
    element: <SettingsPage />,
  },
  {
    path: '/historico',
    element: <HistoryPage />,
  },
  {
    path: '/ai-chat',
    element: <AIChatPage />,
  },
  {
    path: '/ai-chat/:conversationId',
    element: <AIChatPage />,
  },
  {
    path: '/ai-historico',
    element: <AIHistoryPage />,
  },
  {
    path: '/conquistas',
    element: <AchievementsPage />,
  },
  {
    path: '/album',
    element: <AlbumPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacyPage />,
  },
  {
    path: '/termos',
    element: <TermsPage />,
  },
  {
    path: '/sobre',
    element: <AboutPage />,
  },
  {
    path: '/premium/sucesso',
    element: <PremiumSuccessPage />,
  },
  {
    path: '/premium/cancelado',
    element: <PremiumCancelPage />,
  },
  {
    path: '/premium/historico',
    element: <PaymentHistoryPage />,
  },
  {
    path: '/recuperar-senha',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/redefinir-senha',
    element: <ResetPasswordPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;